import MainContainer from "../../components/container/MainContainer";

const DonorsReport = () => {
  const data = {
    headers: [
      "Donor",
      "Ghana (EUR)",
      "Liberia (EUR)",
      "Nigeria (EUR)",
      "Sierra Leone (EUR)",
      "Total Amount (EUR)",
    ],
    rows: [
      {
        donor: "Balance b/f (brought forward 2020)",
        ghana: "",
        liberia: "",
        nigeria: "",
        sierraLeone: "",
        total: 1262574.27,
      },
      {
        donor: "Awra Foundation, Poland",
        ghana: 44199.57,
        liberia: "",
        nigeria: "",
        sierraLeone: "",
        total: 44199.57,
      },
      {
        donor: "AEXCID, CEDECO, Fundación Atabal (Spain)",
        ghana: "",
        liberia: "",
        nigeria: "",
        sierraLeone: "",
        total: "",
      },
      {
        donor: "Adam Szymkowiak",
        ghana: 1280.0,
        liberia: "",
        nigeria: "",
        sierraLeone: "",
        total: 1280.0,
      },
      {
        donor: "BMZ",
        ghana: "",
        liberia: "",
        nigeria: 49219.01,
        sierraLeone: "",
        total: 49219.01,
      },
      {
        donor: "BISTUM MUENSTER - Bishop",
        ghana: 10000.0,
        liberia: "",
        nigeria: "",
        sierraLeone: "",
        total: 10000.0,
      },
      {
        donor: "BINA",
        ghana: 435970.0,
        liberia: "",
        nigeria: "",
        sierraLeone: "",
        total: 435970.0,
      },
      {
        donor: "Bosco Global",
        ghana: 4000.0,
        liberia: "",
        nigeria: "",
        sierraLeone: "",
        total: 4000.0,
      },
      {
        donor: "Beato Michelle Rua",
        ghana: "",
        liberia: "",
        nigeria: 47580.0,
        sierraLeone: "",
        total: 47580.0,
      },
      {
        donor: "CEDECO",
        ghana: "",
        liberia: "",
        nigeria: "",
        sierraLeone: 7973.0,
        total: 7973.0,
      },
      {
        donor: "Don Bosco Jugendhilfe Weltweit, Switzerland",
        ghana: 514707.07,
        liberia: 10463.0,
        nigeria: "",
        sierraLeone: 165054.0,
        total: 690224.07,
      },
      {
        donor: "Don Bosco Mondo e.V. Jugend Hilfe, Weltweit, Germany",
        ghana: 64185.33,
        liberia: 800.0,
        nigeria: "",
        sierraLeone: 216701.0,
        total: 281686.33,
      },
      {
        donor: "Don Bosco Mission, Austria",
        ghana: 58944.61,
        liberia: "",
        nigeria: 32638.0,
        sierraLeone: "",
        total: 91582.61,
      },
      {
        donor: "Direzione Generale Opere Don Bosco",
        ghana: 24946.0,
        liberia: "",
        nigeria: "",
        sierraLeone: "",
        total: 24946.0,
      },
      {
        donor: "Don Bosco Mondo e.V Jugend Eine Welt (Austria)",
        ghana: 14500.0,
        liberia: "",
        nigeria: "",
        sierraLeone: "",
        total: 14500.0,
      },
      {
        donor: "EKI Foundation",
        ghana: "",
        liberia: "",
        nigeria: "",
        sierraLeone: 47704.24,
        total: 47704.24,
      },
      {
        donor: "Fur Sierra Leone",
        ghana: "",
        liberia: "",
        nigeria: "",
        sierraLeone: 8240.0,
        total: 8240.0,
      },
      {
        donor: "Fondation De France",
        ghana: 4980.0,
        liberia: "",
        nigeria: "",
        sierraLeone: "",
        total: 4980.0,
      },
      {
        donor: "FAMI - ITALIAN GOVERNMENT",
        ghana: "",
        liberia: "",
        nigeria: "",
        sierraLeone: 6752.5,
        total: 6752.5,
      },
      {
        donor: "Fundación Heres, Cedeco, Missioni Don Bosco",
        ghana: "",
        liberia: "",
        nigeria: 59890.0,
        sierraLeone: "",
        total: 59890.0,
      },
      {
        donor: "Gerckens-Stiftung",
        ghana: 2500.0,
        liberia: "",
        nigeria: "",
        sierraLeone: 2500.0,
        total: 5000.0,
      },
      {
        donor: "Jacob Christian Foundation",
        ghana: 8244.45,
        liberia: "",
        nigeria: "",
        sierraLeone: "",
        total: 8244.45,
      },
      {
        donor: "Misean Cara, Ireland",
        ghana: 70450.0,
        liberia: "",
        nigeria: "",
        sierraLeone: "",
        total: 70450.0,
      },
      {
        donor: "Missioni Don Bosco, Spain",
        ghana: 435963.9,
        liberia: "",
        nigeria: 797727.15,
        sierraLeone: 232139.0,
        total: 1465828.05,
      },
      {
        donor: "Missioni Don Bosco, Turin",
        ghana: 41616.1,
        liberia: 34300.0,
        nigeria: "",
        sierraLeone: 15324.0,
        total: 91240.1,
      },
      {
        donor: "Manos Unidas, Spain",
        ghana: 47710.0,
        liberia: "",
        nigeria: 125453.0,
        sierraLeone: "",
        total: 173163.0,
      },
      {
        donor: "New Rochelle",
        ghana: "",
        liberia: 40319.5,
        nigeria: "",
        sierraLeone: "",
        total: 40319.5,
      },
      {
        donor: "Oeuvre et Mission Don Bosco",
        ghana: "",
        liberia: 26181.01,
        nigeria: "",
        sierraLeone: "",
        total: 26181.01,
      },
      {
        donor: "SALEZJANSKA FUND",
        ghana: 6300.0,
        liberia: "",
        nigeria: "",
        sierraLeone: "",
        total: 6300.0,
      },
      {
        donor: "Salesian of Don Bosco - Osterreichische Provinz",
        ghana: 1800.0,
        liberia: "",
        nigeria: "",
        sierraLeone: "",
        total: 1800.0,
      },
      {
        donor: "Salesians of Don Bosco, Ireland",
        ghana: "",
        liberia: 96272.0,
        nigeria: "",
        sierraLeone: "",
        total: 96272.0,
      },
      {
        donor: "Van Kesteren Foundation",
        ghana: 10000.0,
        liberia: "",
        nigeria: "",
        sierraLeone: "",
        total: 10000.0,
      },
      {
        donor: "VIS-CEI/ UNO",
        ghana: "",
        liberia: "",
        nigeria: "",
        sierraLeone: 72940.0,
        total: 72940.0,
      },
      {
        donor: "Zupa B.D. Marije Pomocnice",
        ghana: 6439.0,
        liberia: "",
        nigeria: "",
        sierraLeone: "",
        total: 6439.0,
      },
    ],
    total: {
      ghana: 1425953.45,
      liberia: 120197.24,
      nigeria: 1113519.36,
      sierraLeone: 873144.0,
      total: 4795388.32,
    },
  };

  return (
    <MainContainer>
      <h1>ANALYSIS OF DONOR FUNDS FOR THE YEAR ENDED 2021</h1>
      <div className="table-container">
        <table>
          <thead>
            <tr>
              {data.headers.map((header, index) => (
                <th key={index}>{header}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {data.rows.map((row, index) => (
              <tr key={index}>
                <td>{row.donor}</td>
                <td>{row.ghana || "-"}</td>
                <td>{row.liberia || "-"}</td>
                <td>{row.nigeria || "-"}</td>
                <td>{row.sierraLeone || "-"}</td>
                <td>{row.total || "-"}</td>
              </tr>
            ))}
            <tr>
              <td>
                <strong>Total</strong>
              </td>
              <td>
                <strong>{data.total.ghana}</strong>
              </td>
              <td>
                <strong>{data.total.liberia}</strong>
              </td>
              <td>
                <strong>{data.total.nigeria}</strong>
              </td>
              <td>
                <strong>{data.total.sierraLeone}</strong>
              </td>
              <td>
                <strong>{data.total.total}</strong>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </MainContainer>
  );
};

export default DonorsReport;
